import { IServiceConfig, ServiceData } from "providers/venue/types"

export const prepareServicesData = (
  serviceData: ServiceData[]
): IServiceConfig[] =>
  serviceData.map((service) => ({
    id: service.id as string,
    name: service.properties.name,
    description: service.properties.description,
    icon_path: service.properties.icon_path || "",
    icon_image: service.properties.icon_image || "",
    image: service.properties.icon_image || "", //TODO: remove this key later when refactored getIcon function to supporting icon_image key
    feature_image: service.properties.feature_image || "",
    target_device: service.properties.target_device || "all",
    venue_id: service.properties.venue_id || null,
    locations: service.properties.locations || [],
  }))
